import moment from 'moment';
import React from 'react';
import { getClassTypeCities, getClassTypes } from '../../actions/UserAction';
import { onChange, setOptions, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : '',
            minDate: '',
            maxDate: '',
            station: { name: 'station', value: '', options: [], error: '', isRequired: true },
            nameOfHotel: { name: 'nameOfHotel', value: '', error: '', isRequired: true },
            periodOfStay: { name: 'periodOfStay', value: '', error: '', isRequired: true },
            amountClaimed: { name: 'amountClaimed', value: '', error: '', isRequired: true },
            remarks: { name: 'remarks', value: '', error: '', isRequired: true },
            from: { name: 'from', value: '', error: '', isRequired: true },
            to: { name: 'to', value: '', error: '', isRequired: true },
            stationClass : { name: 'stationClass', value: '', options: [], error: '', isRequired: true },

        }
    }

    render() {
        const { station, nameOfHotel, periodOfStay, amountClaimed, remarks,
            stationClass, from, to } = this.state;
        const { showLoader } = this.state;

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label> Class <small>*</small></label>

                                        <select
                                            className={stationClass.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={stationClass.name}
                                            value={stationClass.value}
                                            onChange={this.onChange}

                                        >

                                            <option value="" >Select Class</option>

                                               
                                                {
                                                stationClass && stationClass.options.length > 0 ?
                                                    stationClass.options.map((ele: any, index: any) => {
                                                        return (
                                                            <>
                                                                <option value={ele.class} key={index} >{ele.class}</option>
                                                            </>
                                                        )
                                                    }) : ""


                                            }


                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label> Station <small>*</small></label>

                                        {
                                            stationClass.value != "B-2/C" ?
                                                <select
                                                    className={station.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    name={station.name}
                                                    value={station.value}
                                                    onChange={this.onChange}
                                                >
                                                    {
                                                        station && station.options.length > 0 ?
                                                            station.options.map((ele: any, index: any) => {
                                                                return (
                                                                    <>
                                                                        <option value={ele.cities} key={index}  >{ele.cities}</option>
                                                                    </>
                                                                )
                                                            }) : ""

                                                    }
                                                </select> :
                                                <input
                                                    className={station.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                    name={station.name}
                                                    value={station.value}
                                                    onChange={this.onChange}
                                                    placeholder="Others Cities" />

                                        }

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Name Of Hotel <small>*</small></label>
                                        <input
                                            type="text"
                                            className={nameOfHotel.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={nameOfHotel.name}
                                            value={nameOfHotel.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Period Of Stay (in days)<small>*</small></label>
                                        <input
                                            type="text"
                                            className={periodOfStay.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={periodOfStay.name}
                                            value={periodOfStay.value ? periodOfStay.value : ''}
                                            onChange={this.onChange}
                                            maxLength={2}
                                        // inputmode="numeric"
                                        // min={moment().subtract(2, 'month').format('YYYY-MM-DD')}
                                        // max={moment().add(3, 'month').format('YYYY-MM-DD')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>amountClaimed <small>*</small></label>
                                        <input
                                            type="number"
                                            className={amountClaimed.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={amountClaimed.name}
                                            value={amountClaimed.value}
                                            onChange={this.onChange}
                                            step="any"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label> from <small>*</small></label>
                                        <input
                                            type="date"
                                            className={from.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={from.name}
                                            value={from.value}
                                            onChange={this.onChange}
                                            min={moment().subtract(2, 'month').format('YYYY-MM-DD')}
                                            max={moment().add(3, 'month').format('YYYY-MM-DD')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label> to <small>*</small></label>
                                        <input
                                            type="date"
                                            className={to.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={to.name}
                                            value={to.value}
                                            onChange={this.onChange}
                                            min={moment().subtract(2, 'month').format('YYYY-MM-DD')}
                                            max={moment().add(3, 'month').format('YYYY-MM-DD')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>remarks <small>*</small></label>
                                        <textarea
                                            className={station.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            value={remarks.value}
                                            name={remarks.name}
                                            onChange={this.onChange}
                                        />
                                        {/* <input
                                            type="time"
                                            className={remarks.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={remarks.name}
                                            value={remarks.value}
                                            onChange={this.onChange}
                                        /> */}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
    componentDidMount() {
        // const sd = moment().subtract(2, 'month').format('YYYY-MM-DD');
        // const ed = moment().add(3, 'month').format('YYYY-MM-DD');
        // this.setState({
        //     minDate: sd,
        //     maxDate: ed
        // });

        getClassTypes().then((res: any) => {
            setOptions(this, this.state.stationClass.name, res.result);
        });
    }


    componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
        const { station, stationClass, } = this.state

        if (prevState.stationClass.value != stationClass.value) {
            getClassTypeCities(stationClass.value).then((res: any) => {
                setOptions(this, this.state.station.name, res.result);
                });

        }

    }


    onChange = (e: any) => {

        onChange(this, e.target.name, e.target.value, () => {
            
        });
    }


    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            this.setState({ showLoader: true });
            const model = {
                // id: st.id,
                stationClass: st.stationClass.value ,
                station: st.station.value,
                nameOfHotel: st.nameOfHotel.value,
                periodOfStay: st.periodOfStay.value,
                amountClaimed: st.amountClaimed.value,
                fromDate: st.from.value,
                toDate: st.to.value,
                remarks: st.remarks.value,
                // fare: parseFloat(st.fare.value),
                // da: parseFloat(st.da.value),
            };
            // if (st.id === "") {
            //     model.id = new Date().getTime();
            // }
            this.props.onSubmit(model);
        }
    }

    // compareDates = () => {
    //     const st = this.state;
    //     const startDate = moment(st.startDate.value);
    //     const endDate = moment(st.endDate.value);
    //     const diff = endDate.diff(startDate);

    //     if (diff >= 0) {
    //         return true;
    //     } else {
    //         alert('Start date must be less than end date');
    //         return false;
    //     }
    // }
}

export default ComponentName;